<template>
  <InboxEmpty v-if="empty && selectedCategory === FILTERED_CATEGORY" />
  <InboxFilteredPanel v-else-if="selectedCategory === FILTERED_CATEGORY" />
  <InboxAllPanel v-else-if="selectedCategory === ALL_CATEGORY" />
  <InboxUnreadPanel v-else-if="selectedCategory === UNREAD_CATEGORY" />
  <InboxTalkingPointBucketPanel
    v-else-if="selectedCategory === CLIENT_MEETING_CATEGORY"
    :bucket="selectedItem"
    :items="groupedCommunication[selectedCategory]?.[selectedItem] ?? []"
  />
  <InboxSectionPanel
    v-else
    :items="groupedCommunication[selectedCategory]?.[selectedItem] ?? []"
  />
</template>

<script setup>
import { computed } from 'vue'

import {
  ALL_CATEGORY,
  CLIENT_MEETING_CATEGORY,
  FILTERED_CATEGORY,
  UNREAD_CATEGORY,
} from '@app/application/communication/screens/inbox/store/utils'
import InboxEmpty from '@app/application/communication/screens/inbox/components/inbox-empty.vue'
import InboxFilteredPanel from '@app/application/communication/screens/inbox/components/inbox-filtered-panel.vue'
import InboxUnreadPanel from '@app/application/communication/screens/inbox/components/inbox-unread-panel.vue'
import InboxSectionPanel from '@app/application/communication/screens/inbox/components/inbox-section-panel.vue'
import InboxTalkingPointBucketPanel from '@app/application/communication/screens/inbox/components/inbox-talking-point-bucket-panel.vue'
import useGroupedFilteredCommunications from '@app/application/communication/screens/inbox/composables/use-grouped-filtered-communications'
import InboxAllPanel from '@app/application/communication/screens/inbox/components/inbox-all-panel.vue'

defineProps({
  selectedCategory: {
    type: String,
    required: true,
  },
  selectedItem: {
    type: String,
    required: true,
  },
})

const { groupedCommunication } = useGroupedFilteredCommunications()
const empty = computed(
  () => Object.keys(groupedCommunication.value).length === 0
)
</script>
